<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="700px"
      @click:outside="cerrarDialogo()"
      content-class="incident-dialog-wrap"
    >
      <v-card class="incident-form-card">
        <!-- Cabecera de la Modal -->
        <div
          class="incident-form-header px-6 py-4 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center">
            <div class="header-icon-box mr-3">
              <v-icon color="teal darken-2">mdi-plus-circle-outline</v-icon>
            </div>
            <div>
              <div class="header-modal-title">Registrar Nueva Incidencia</div>
              <div class="d-flex align-center mt-1">
                <span class="header-tag-badge">
                  <v-icon x-small class="mr-1" color="teal"
                    >mdi-shield-alert-outline</v-icon
                  >
                  Soporte & Reporte Operativo
                </span>
              </div>
            </div>
          </div>
          <v-btn
            icon
            small
            class="close-form-btn"
            @click="cerrarDialogo()"
            aria-label="Cerrar modal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="incident-form-body px-6 py-4">
          <!-- Sección 1: Datos del Cliente -->
          <div class="section-card mb-4">
            <div class="section-card-header d-flex align-center">
              <div class="section-icon-dot bg-blue mr-2"></div>
              <v-icon small color="primary" class="mr-2">mdi-domain</v-icon>
              <span class="section-card-title">Datos del Cliente</span>
            </div>
            <div class="section-card-content pt-3">
              <v-row dense>
                <v-col cols="12" sm="7">
                  <v-text-field
                    label="Razón Social *"
                    hide-details="auto"
                    v-model="Cliente.razon_social"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-office-building-outline"
                    class="custom-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-text-field
                    label="RUC *"
                    hide-details="auto"
                    v-model="Cliente.ruc"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-card-account-details-outline"
                    class="custom-field"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Sección 2: Detalles del Incidente -->
          <div class="section-card mb-4">
            <div class="section-card-header d-flex align-center">
              <div class="section-icon-dot bg-amber mr-2"></div>
              <v-icon small color="amber darken-3" class="mr-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="section-card-title">Detalles del Incidente</span>
            </div>
            <div class="section-card-content pt-3">
              <v-form ref="form" v-model="valid">
                <!-- Descripción -->
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      label="Descripción detallada de la incidencia *"
                      placeholder="Describe los hechos, observaciones o requerimiento..."
                      v-model="item.descripcion"
                      :rules="descripcionRules"
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      prepend-inner-icon="mdi-text-box-outline"
                      class="custom-field"
                    />
                  </v-col>
                </v-row>

                <!-- Carga de Imágenes de Evidencia con Previsualizador -->
                <div class="upload-section mt-2">
                  <div class="d-flex align-center mb-2">
                    <v-icon small color="blue-grey" class="mr-2"
                      >mdi-camera-outline</v-icon
                    >
                    <span class="evidence-label"
                      >Adjuntar Fotografías / Evidencias</span
                    >
                  </div>
                  <v-row dense>
                    <!-- Fotografía 1 -->
                    <v-col cols="12" sm="6">
                      <div class="upload-box">
                        <div class="upload-box-header">
                          <span class="d-flex align-center">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-image-plus</v-icon
                            >
                            Fotografía 1
                          </span>
                          <span class="preview-badge" v-if="preview1">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-check</v-icon
                            >
                            Cargada
                          </span>
                        </div>
                        <div class="upload-box-body pa-2">
                          <!-- Previsualizador de Imagen 1 si ya fue seleccionada -->
                          <div v-if="preview1" class="img-preview-container">
                            <div
                              class="preview-img-wrapper"
                              @click="verImagenGrande(preview1)"
                              title="Click para ampliar imagen"
                            >
                              <img
                                :src="preview1"
                                alt="Evidencia 1"
                                class="preview-thumb"
                              />
                              <div class="preview-overlay">
                                <v-icon small color="white"
                                  >mdi-magnify-plus-outline</v-icon
                                >
                                <span
                                  class="text-caption white--text font-weight-medium ml-1"
                                  >Ampliar</span
                                >
                              </div>
                            </div>
                            <div
                              class="d-flex align-center justify-space-between mt-2 px-1"
                            >
                              <span
                                class="text-caption text-truncate grey--text text--darken-2 font-weight-medium"
                              >
                                Imagen 1 lista
                              </span>
                              <v-btn
                                text
                                x-small
                                color="red darken-1"
                                class="px-1 text-capitalize"
                                @click="eliminarImagen1()"
                              >
                                <v-icon x-small class="mr-1"
                                  >mdi-delete-outline</v-icon
                                >
                                Cambiar
                              </v-btn>
                            </div>
                          </div>

                          <!-- File Input (visible cuando no hay preview, pero siempre en el DOM con ID) -->
                          <v-file-input
                            v-show="!preview1"
                            id="img_firma1"
                            v-model="file1"
                            label="Seleccionar imagen 1"
                            outlined
                            dense
                            hide-details="auto"
                            prepend-icon=""
                            prepend-inner-icon="mdi-camera-plus-outline"
                            accept="image/png, .jpeg, .jpg"
                            @change="subirImagen1"
                            class="custom-field"
                          ></v-file-input>
                        </div>
                      </div>
                    </v-col>

                    <!-- Fotografía 2 -->
                    <v-col cols="12" sm="6">
                      <div class="upload-box">
                        <div class="upload-box-header">
                          <span class="d-flex align-center">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-image-plus</v-icon
                            >
                            Fotografía 2
                          </span>
                          <span class="preview-badge" v-if="preview2">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-check</v-icon
                            >
                            Cargada
                          </span>
                        </div>
                        <div class="upload-box-body pa-2">
                          <!-- Previsualizador de Imagen 2 si ya fue seleccionada -->
                          <div v-if="preview2" class="img-preview-container">
                            <div
                              class="preview-img-wrapper"
                              @click="verImagenGrande(preview2)"
                              title="Click para ampliar imagen"
                            >
                              <img
                                :src="preview2"
                                alt="Evidencia 2"
                                class="preview-thumb"
                              />
                              <div class="preview-overlay">
                                <v-icon small color="white"
                                  >mdi-magnify-plus-outline</v-icon
                                >
                                <span
                                  class="text-caption white--text font-weight-medium ml-1"
                                  >Ampliar</span
                                >
                              </div>
                            </div>
                            <div
                              class="d-flex align-center justify-space-between mt-2 px-1"
                            >
                              <span
                                class="text-caption text-truncate grey--text text--darken-2 font-weight-medium"
                              >
                                Imagen 2 lista
                              </span>
                              <v-btn
                                text
                                x-small
                                color="red darken-1"
                                class="px-1 text-capitalize"
                                @click="eliminarImagen2()"
                              >
                                <v-icon x-small class="mr-1"
                                  >mdi-delete-outline</v-icon
                                >
                                Cambiar
                              </v-btn>
                            </div>
                          </div>

                          <!-- File Input (visible cuando no hay preview, pero siempre en el DOM con ID) -->
                          <v-file-input
                            v-show="!preview2"
                            id="img_firma2"
                            v-model="file2"
                            label="Seleccionar imagen 2"
                            outlined
                            dense
                            hide-details="auto"
                            prepend-icon=""
                            prepend-inner-icon="mdi-camera-plus-outline"
                            accept="image/png, .jpeg, .jpg"
                            @change="subirImagen2"
                            class="custom-field"
                          ></v-file-input>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Sección 3: Vinculación Opcional de Vehículo / Neumático -->
                <div class="association-section mt-4">
                  <div class="d-flex align-center mb-1">
                    <v-icon small color="teal darken-2" class="mr-2"
                      >mdi-link-variant</v-icon
                    >
                    <span class="evidence-label"
                      >Vincular Vehículo o Neumático (Opcional)</span
                    >
                  </div>

                  <div class="info-callout mb-3 d-flex align-center">
                    <v-icon small color="blue" class="mr-2 flex-shrink-0"
                      >mdi-information-outline</v-icon
                    >
                    <span>
                      Selecciona una placa y neumático solo si la incidencia
                      involucra una unidad específica. De lo contrario, puedes
                      dejar estos campos en blanco.
                    </span>
                  </div>

                  <v-row dense align="center">
                    <v-col cols="12" sm="5">
                      <v-autocomplete
                        @change="onCargarNeumaticos()"
                        :items="vehiculos"
                        v-model="incidente.id_vehiculo"
                        label="Seleccionar Placa"
                        placeholder="Busca por placa..."
                        outlined
                        dense
                        hide-details="auto"
                        prepend-inner-icon="mdi-truck-outline"
                        class="custom-field"
                      />
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-autocomplete
                        @change="onSerieNeumatico()"
                        :items="neumaticos"
                        v-model="incidente.id_neumatico"
                        label="Seleccionar Neumático"
                        placeholder="Busca por serie..."
                        outlined
                        dense
                        hide-details="auto"
                        prepend-inner-icon="mdi-barcode"
                        class="custom-field"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      class="d-flex align-center justify-end"
                    >
                      <v-btn
                        @click="agregarIncidencia()"
                        color="teal darken-1"
                        class="btn-add-item white--text text-capitalize"
                        elevation="0"
                        block
                      >
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Tabla de items vinculados -->
                  <div class="custom-table-wrapper mt-3">
                    <v-data-table
                      dense
                      :headers="cabecera"
                      :items="items"
                      :items-per-page="5"
                      class="custom-elevation-table"
                      loading-text="Cargando... Por favor, espere"
                      no-data-text="No se han vinculado vehículos o neumáticos aún"
                      :footer-props="{
                        'items-per-page-text': 'Filas por página:',
                        'page-text': '{0}-{1} de {2}',
                      }"
                    >
                      <template v-slot:[`item.placa_vehiculo`]="{ item }">
                        <span class="badge-placa">
                          <v-icon x-small class="mr-1" color="primary"
                            >mdi-truck</v-icon
                          >
                          {{ item.placa_vehiculo || item.placa }}
                        </span>
                      </template>
                      <template v-slot:[`item.serie_neumatico`]="{ item }">
                        <span class="badge-serie">
                          <v-icon x-small class="mr-1" color="grey darken-2"
                            >mdi-barcode</v-icon
                          >
                          {{ item.serie_neumatico || item.serie }}
                        </span>
                      </template>
                      <template v-slot:[`item.accion`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              class="delete-item-btn"
                              @click="eliminarItem(item)"
                              v-bind="attrs"
                              v-on="on"
                              aria-label="Eliminar fila"
                            >
                              <v-icon small color="red darken-1"
                                >mdi-delete-outline</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>Quitar elemento</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
        </v-card-text>

        <!-- Pie de la Modal / Acciones -->
        <v-divider></v-divider>
        <v-card-actions class="incident-form-actions px-6 py-3">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="btn-form-secondary text-capitalize"
            @click="cerrarDialogo()"
          >
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cerrar
          </v-btn>
          <v-btn
            color="teal darken-1"
            class="btn-form-primary white--text text-capitalize ml-2"
            @click="guardarIncidencia()"
            :loading="loading"
            elevation="0"
          >
            <v-icon small class="mr-1">mdi-send-outline</v-icon>
            Enviar Incidencia
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Modal para ampliar la fotografía -->
    <v-dialog v-model="dialogPreview" max-width="820px">
      <v-card class="preview-lightbox-card">
        <div
          class="preview-lightbox-header px-4 py-3 d-flex justify-space-between align-center"
        >
          <div class="d-flex align-center">
            <v-icon small color="teal darken-2" class="mr-2"
              >mdi-image-search-outline</v-icon
            >
            <span class="text-subtitle-2 font-weight-bold"
              >Vista Previa de Fotografía</span
            >
          </div>
          <v-btn
            icon
            small
            @click="dialogPreview = false"
            aria-label="Cerrar vista previa"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="preview-lightbox-body pa-4 text-center">
          <img
            :src="imagenSeleccionadaPreview"
            alt="Vista previa ampliada"
            class="preview-full-img"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { notif } from "@/plugins/notyf";

export default {
  props: ["dialog"],
  data() {
    return {
      valid: false,
      loading: false,
      incidente: {},
      descripcionRules: [
        (v) => !!v || "Descripción es requerido",
        (v) =>
          (v && v.length <= 1000) ||
          "Descripción debe tener menos de 1000 caracteres",
      ],
      item: {
        aplicativo: "vue",
        descripcion: "",
        image_one: null,
        image_two: null,
      },
      cabecera: [
        {
          text: "Placa",
          value: "placa_vehiculo",
          width: 200,
          class: "table-header-cell",
        },
        {
          text: "Serie de Neumático",
          value: "serie_neumatico",
          width: 200,
          class: "table-header-cell",
        },
        {
          text: "Acción",
          value: "accion",
          width: 90,
          align: "center",
          sortable: false,
          class: "table-header-cell",
        },
      ],
      items: [],
      vehiculo: {},
      vehiculos: [],
      neumaticos: [],
      incidente: {
        placa: null,
        serie: null,
        id_neumatico: null,
        id_vehiculo: null,
      },
      nombreusuario: "",
      preview1: null,
      preview2: null,
      file1: null,
      file2: null,
      dialogPreview: false,
      imagenSeleccionadaPreview: "",
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
  },
  methods: {
    ...mapActions("vehiculo", [
      "cargarVehiculosMinified",
      "cargarNeumaticosPorId",
    ]),
    ...mapActions("neumatico", ["cargarNeumaticosMinified"]),
    ...mapActions("incidente", ["subirImagenes", "guardarIncidente"]),
    ...mapActions("cliente", ["ObtenerDatosCliente"]),

    verImagenGrande(src) {
      if (src) {
        this.imagenSeleccionadaPreview = src;
        this.dialogPreview = true;
      }
    },

    eliminarImagen1() {
      this.preview1 = null;
      this.item.image_one = null;
      this.file1 = null;
      const input = document.getElementById("img_firma1");
      if (input) input.value = "";
    },

    eliminarImagen2() {
      this.preview2 = null;
      this.item.image_two = null;
      this.file2 = null;
      const input = document.getElementById("img_firma2");
      if (input) input.value = "";
    },

    async onCargarNeumaticos() {
      try {
        this.neumaticos = await this.cargarNeumaticosPorId(
          this.incidente.id_vehiculo,
        );
        this.vehiculos.forEach((element) => {
          if (element.value == this.incidente.id_vehiculo) {
            this.incidente.placa_vehiculo = element.text;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    onSerieNeumatico() {
      this.neumaticos.forEach((element) => {
        if (element.value == this.incidente.id_neumatico) {
          this.incidente.serie_neumatico = element.text;
        }
      });
    },

    async guardarIncidencia() {
      let status = false;
      if (this.$refs.form.validate()) {
        try {
          let datosaenviar = { incidente: this.item, detalles: this.items };
          status = await this.guardarIncidente(datosaenviar);
          if (status == true) {
            notif.success("Incidencia enviada con éxito");
            this.cerrarDialogo();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    agregarIncidencia() {
      let existe = false;
      this.items.forEach((element) => {
        if (
          element.id_vehiculo == this.incidente.id_vehiculo &&
          element.id_neumatico == this.incidente.id_neumatico
        ) {
          existe = true;
        }
      });
      //Si el neumatico no esta en el array incidentes registrar
      if (!existe) {
        if (
          this.incidente.id_vehiculo != null &&
          this.incidente.id_neumatico != null
        ) {
          this.items.push({ ...this.incidente });
        } else {
          if (this.incidente.id_vehiculo == null) {
            notif.open({
              type: "warning",
              message: "La placa del vehículo es requerida",
            });
          } else {
            notif.open({
              type: "warning",
              message: "La serie de neumático es requerida",
            });
          }
        }
      } else {
        notif.open({
          type: "warning",
          message: "El neumático seleccionado ya a sido agregado",
        });
      }
      this.incidente.serie_neumatico = null;
      this.incidente.id_neumatico = null;
    },

    eliminarItem(item) {
      const pos = this.items.indexOf(item);
      this.items.splice(pos, 1);
    },

    async subirImagen1(eventOrFile) {
      try {
        let file =
          eventOrFile && eventOrFile instanceof File
            ? eventOrFile
            : document.getElementById("img_firma1")
            ? document.getElementById("img_firma1").files[0]
            : null;

        if (file) {
          this.preview1 = URL.createObjectURL(file);
          this.item.image_one = await this.subirImagenes(file);
        } else {
          this.preview1 = null;
          this.item.image_one = null;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async subirImagen2(eventOrFile) {
      try {
        let file =
          eventOrFile && eventOrFile instanceof File
            ? eventOrFile
            : document.getElementById("img_firma2")
            ? document.getElementById("img_firma2").files[0]
            : null;

        if (file) {
          this.preview2 = URL.createObjectURL(file);
          this.item.image_two = await this.subirImagenes(file);
        } else {
          this.preview2 = null;
          this.item.image_two = null;
        }
      } catch (error) {
        console.log(error);
      }
    },

    cerrarDialogo() {
      this.preview1 = null;
      this.preview2 = null;
      this.file1 = null;
      this.file2 = null;
      this.$emit("cerrarModalIncidencias");
    },
  },
  async mounted() {
    this.vehiculos = await this.cargarVehiculosMinified();
    this.nombreusuario = localStorage.getItem("name");
  },
};
</script>

<style scoped>
.incident-form-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.incident-form-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.header-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #ccfbf1;
  border: 1px solid #99f6e4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.header-tag-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: #ccfbf1;
  color: #0f766e;
  border: 1px solid #99f6e4;
}

.close-form-btn {
  color: #64748b !important;
  transition: all 0.2s ease;
}

.close-form-btn:hover {
  background: #f1f5f9;
  color: #0f172a !important;
}

.incident-form-body {
  max-height: 72vh;
  overflow-y: auto;
  background: #ffffff;
}

/* Scrollbar estilizado */
.incident-form-body::-webkit-scrollbar {
  width: 6px;
}
.incident-form-body::-webkit-scrollbar-track {
  background: #f8fafc;
}
.incident-form-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.incident-form-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tarjetas de sección */
.section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  transition: all 0.2s ease;
}

.section-card:hover {
  border-color: #cbd5e1;
}

.section-card-header {
  border-bottom: 1px dashed #f1f5f9;
  padding-bottom: 8px;
}

.section-icon-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.bg-blue {
  background-color: #3b82f6;
}

.bg-amber {
  background-color: #f59e0b;
}

.section-card-title {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Estilos de inputs */
::v-deep .custom-field .v-input__slot {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}

::v-deep .custom-field input,
::v-deep .custom-field textarea {
  color: #1e293b !important;
  font-weight: 500;
}

::v-deep .custom-field .v-icon {
  font-size: 17px !important;
  color: #94a3b8 !important;
}

/* Subida de evidencias */
.evidence-label {
  font-size: 11.5px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.upload-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.upload-box:hover {
  border-color: #cbd5e1;
}

.upload-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: #f1f5f9;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
}

.preview-badge {
  font-size: 10.5px;
  font-weight: 700;
  color: #0f766e;
  background: #ccfbf1;
  padding: 1px 7px;
  border-radius: 4px;
}

/* Previsualizador de Imagen */
.img-preview-container {
  width: 100%;
}

.preview-img-wrapper {
  position: relative;
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #0f172a;
}

.preview-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.preview-img-wrapper:hover .preview-thumb {
  transform: scale(1.05);
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.preview-img-wrapper:hover .preview-overlay {
  opacity: 1;
}

.preview-lightbox-card {
  border-radius: 14px;
  overflow: hidden;
}

.preview-lightbox-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.preview-full-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* Cuadro de llamada / info */
.info-callout {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 11.5px;
  color: #0369a1;
  line-height: 1.35;
}

.btn-add-item {
  border-radius: 8px !important;
  height: 40px !important;
  font-weight: 600 !important;
}

/* Tabla personalizada */
.custom-table-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

::v-deep .table-header-cell {
  background-color: #f1f5f9 !important;
  color: #475569 !important;
  font-weight: 700 !important;
  font-size: 11.5px !important;
}

.badge-placa {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 700;
  font-size: 11px;
  border: 1px solid #dbeafe;
}

.badge-serie {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f8fafc;
  color: #334155;
  font-weight: 600;
  font-size: 11px;
  border: 1px solid #e2e8f0;
}

.delete-item-btn:hover {
  background: #fee2e2 !important;
}

.incident-form-actions {
  background: #f8fafc;
}

.btn-form-secondary {
  border-radius: 8px !important;
  color: #64748b !important;
  border-color: #cbd5e1 !important;
}

.btn-form-secondary:hover {
  background: #f1f5f9 !important;
  color: #1e293b !important;
}

.btn-form-primary {
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.25) !important;
}
</style>
